// import React from 'react';
// import { motion } from 'motion/react';
// import { useInView } from 'react-intersection-observer';

// export function About() {
//   const [ref, inView] = useInView({
//     triggerOnce: true,
//     threshold: 0.2,
//   });

//   return (
//     <section id="about-us" className="py-20 lg:py-32 px-4 sm:px-6 lg:px-20 relative">
//       <div className="absolute inset-0 bg-gradient-to-b from-transparent via-accent/5 to-transparent dark:via-accent/10" />

//       <div className="max-w-4xl mx-auto relative">
//         <motion.div
//           ref={ref}
//           initial={{ opacity: 0, y: 40 }}
//           animate={inView ? { opacity: 1, y: 0 } : {}}
//           transition={{ duration: 0.8 }}
//           className="text-center"
//         >
//           <motion.h2
//             initial={{ opacity: 0, y: 20 }}
//             animate={inView ? { opacity: 1, y: 0 } : {}}
//             transition={{ delay: 0.2 }}
//             className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6"
//           >
//             About{' '}
//             <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
//               NFC Design Studio
//             </span>
//           </motion.h2>

//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={inView ? { opacity: 1, y: 0 } : {}}
//             transition={{ delay: 0.4 }}
//             className="bg-card/50 backdrop-blur-sm border border-border rounded-2xl p-8 lg:p-12 shadow-xl"
//           >
//             <p className="text-lg text-muted-foreground leading-relaxed">
//               NFC Design Studio helps professionals and businesses replace traditional paper cards 
//               with smart, eco-friendly digital business cards powered by NFC and QR technology. 
//               Our platform makes it easy to create stunning digital cards, share them instantly, 
//               and keep your contact information always up-to-date. Join thousands of professionals 
//               who are networking smarter and more sustainably.
//             </p>
//           </motion.div>
//         </motion.div>
//       </div>
//     </section>
//   );
// }


import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const About = () => {
  const [inView, setInView] = useState(false);

  // Scroll detection for animation
  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById("about-us");
      if (section) {
        const rect = section.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.8) {
          setInView(true);
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll(); // check immediately
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section
      id="about-us"
      style={{
        position: "relative",
        paddingTop: "80px",
        paddingBottom: "80px",
        paddingLeft: "16px",
        paddingRight: "16px",
        overflow: "hidden",
        background: "linear-gradient(to bottom, transparent, rgba(34,211,238,0.05), transparent)",
      }}
    >
      <div style={{ maxWidth: "1024px", margin: "0 auto", position: "relative" }}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          style={{ textAlign: "center" }}
        >
          {/* Heading */}
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.2 }}
            style={{
              fontSize: "2.5rem",
              fontWeight: "bold",
              marginBottom: "24px",
              lineHeight: 1.2,
              color: "#111",
            }}
          >
            About{" "}
            <span
              style={{
                background: "linear-gradient(to right, #6366f1, #22d3ee, #facc15)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              NFC Design Studio
            </span>
          </motion.h2>

          {/* Description Card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.4 }}
            style={{
              background: "rgba(255,255,255,0.5)",
              backdropFilter: "blur(8px)",
              border: "1px solid rgba(34,211,238,0.2)",
              borderRadius: "24px",
              padding: "32px",
              boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
              fontSize: "1.125rem",
              color: "#6b7280",
              lineHeight: 1.6,
            }}
          >
            NFC Design Studio helps professionals and businesses replace traditional paper cards
            with smart, eco-friendly digital business cards powered by NFC and QR technology.
            Our platform makes it easy to create stunning digital cards, share them instantly,
            and keep your contact information always up-to-date. Join thousands of professionals
            who are networking smarter and more sustainably.
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
